// First file converted in the JS -> TS migration (Phase 1 proof-of-concept).
// Pure numeric leaf with no imports; many analysis modules depend on it, so its
// exported signatures flow type information outward into every consumer.
// Runtime behavior is unchanged from the original math.js -- only types added.

export interface Extent {
  min: number;
  max: number;
}

export function extentFromValues(values: readonly number[]): Extent | null {
  let min = Infinity;
  let max = -Infinity;
  let found = false;
  values.forEach((value) => {
    if (!Number.isFinite(value)) return;
    min = Math.min(min, value);
    max = Math.max(max, value);
    found = true;
  });
  return found ? { min, max } : null;
}

export function sumFiniteValues(values: readonly number[]): number | null {
  const finite = values.filter(Number.isFinite);
  return finite.length ? finite.reduce((total, value) => total + value, 0) : null;
}

export function averageValues(values: readonly number[]): number | null {
  const finite = values.filter(Number.isFinite);
  return finite.length ? finite.reduce((total, value) => total + value, 0) / finite.length : null;
}

export function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function seededNoise(index: number, scale = 1): number {
  return ((Math.sin(index * 12.9898) * 43758.5453) % 1) * scale;
}
